import { createSelector } from 'reselect'
import userLoggedSelector from 'redux/selectors/user_extra_data/user_logged_selector'

const qsSelector = state => state.qs

export default createSelector(
	[userLoggedSelector, qsSelector],
	(isUserLogged, qsSelectorData) => ({
		isUserLogged,
		canLinkToHome: qsSelectorData.isMsft !== '1' && qsSelectorData.from_google_slides !== '1',
	})
)
